export const AUTH_TOKEN = 'Authorization';

export const LOCAL_STORAGE = {
  ID_TOKEN: 'token',
  USER: 'user',
};

export const HOME_PATH = '/';
export const SITE_URL = 'https://sportsfeed24.st';
export const SITE_NAME = 'SportsFeed24';

export const PAGE_TITLES: any = {
  WEBSITE_TITLE: 'SportsFeed24 – Free Live Soccer Streams, Football, Cricket, NFL, NBA & UFC |sportsfeed24',
  SOCCER: 'Live Soccer Streams & Football Fixtures – Premier League, Champions League |Sportsfeed24',
  BOXING: 'Free Boxing Live Streams & Upcoming Fight Schedules |Sportsfeed24',
  NFL: 'Free NFL Live Streams – Every Game, Playoffs & Super Bowl |Sportsfeed24',
  NBA: 'Free NBA Live Streams – Regular Season & Playoffs in HD |Sportsfeed24',
  UFC: 'Free UFC Live Streams – Fight Night & PPV Events |Sportsfeed24',
  MMA: 'Free MMA & UFC Live Streams – Fight Night & PPV Coverage |Sportsfeed24',
  TENNIS: 'Live Tennis Streams & Match Fixtures |Sportsfeed24',
  RUGBY: 'Free Rugby Live Streams & Match Schedules |Sportsfeed24',
  MOTOGP: 'Free MotoGP Live Streams & Race Schedules |Sportsfeed24',
  NHL: 'Free NHL Live Streams & Game Fixtures |Sportsfeed24',
  MLB: 'Free MLB Live Streams & Season Schedules |Sportsfeed24',
  F1: 'Free F1 Live Streams – Grand Prix & Race Coverage |Sportsfeed24',
  MLS: 'Free MLS Live Streams & Match Fixtures |Sportsfeed24',
  CRICKET: 'Live Cricket Streams – PSL, IPL, T20, ODI & Test Matches |Sportsfeed24',
  NASCAR: 'Free NASCAR Live Streams & Race Schedules |Sportsfeed24',
  CONTACT: 'Contact SportsFeed24 – Feedback & Support |sportsfeed24',
  ABOUT: 'About SportsFeed24 – Free Live Sports Streaming Platform |sportsfeed24'
}

export const categories = [
  {
    label: 'Soccer',
    value: 'Soccer'
  },
  {
    label: 'F1',
    value: 'F1'
  },
  {
    label: 'Tennis',
    value: 'tennis'
  },
  {
    label: 'Boxing',
    value: 'Boxing'
  },
  {
    label: 'UFC',
    value: 'UFC'
  },
  {
    label: 'Motogp',
    value: 'motogp'
  },
  {
    label: 'NFL',
    value: 'NFL'
  },
  {
    label: 'NBA',
    value: 'NBA'
  },
  {
    label: 'MMA',
    value: 'UFC'
  },
  {
    label: 'NHL',
    value: 'NHL'
  },
  {
    label: 'Rugby',
    value: 'Rugby'
  },
  // {
  //   label: 'Cricket',
  //   value: 'cricket'
  // }
  {
    label: 'MLB',
    value: 'MLB'
  },
  {
    label: 'MLS',
    value: 'MLS'
  }
];

export const MESSAGES = {
  EMAIL_SUCCESS: 'Your email has been sent successfully!',
  EMAIL_FAILURE: 'Unable to sent email!',
  ADD_STREAM_SUCCESS: 'Player added successfully!',
  ADD_STREAM_FAILURE: 'Failed to add player!',
  UPDATE_STREAM_SUCCESS: 'Streams updated successfully!',
  UPDATE_STREAM_FAILURE: 'Failed to add sreeams!',
  AUTH_SUCCESS: 'User Authenticated!',
  AUTH_FAILURE: 'Invalid user or password!'
}

export const LOGO_URL = 'https://d22vy4ldq8bjtm.cloudfront.net/images/special/Sportsfeed24-Logo-Official.webp';

export const MENU_CATEGORIES = [
  {
    label: 'Soccer',
    value: 'Soccer'
  },
  {
    label: 'NFL',
    value: 'nfl'
  },
  {
    label: 'F1',
    value: 'F1'
  },
  {
    label: 'NBA',
    value: 'nba'
  },
  {
    label: 'Boxing',
    value: 'Boxing'
  },
  {
    label: 'MMA/UFC',
    value: 'mma'
  },
  {
    label: 'NHL',
    value: 'nhl'
  },
  {
    label: 'MLS',
    value: 'mls'
  },
  {
    label: 'MLB',
    value: 'mlb'
  },
  {
    label: 'Motogp',
    value: 'MOTOGP'
  },
  {
    label: 'Rugby',
    value: 'Rugby'
  }
  // {
  //   label: 'WWE',
  //   value: 'WWE'
  // },
];

export const CATEGORY_LINKS:any = {
  SOCCER: 'Soccer',
  NFL: 'nfl',
  F1: 'F1',
  NBA: 'nba',
  BOXING: 'Boxing',
  UFC: 'ufc',
  NHL: 'nhl',
  MLS: 'mls',
  MLB: 'mlb',
  MOTOGP: 'MOTOGP',
  RUGBY: 'Rugby',
  TENNIS: 'tennis',
  NASCAR: 'NASCAR',
  WWE: 'WWE'
};

export const ADS = {
  MAIN: {
    TYPE: 'main',
    SLOT: '2554300823'
  },
  FIXTURE_LIST_DISPLAY_HORIZONTAL: {
    TYPE: 'FixtureListDisplayHorizontal',
    SLOT: '3824669050'
  },
  PLAYER_DISPLAY_HORIZONTAL: {
    TYPE: 'playerDisplayHorizontal',
    SLOT: '3744778007'
  },
  VERTICLE_MAIN: {
    TYPE: 'vertical',
    SLOT: '2926488530'
  },
  IN_ARTICLE: {
    TYPE: 'in-article',
    SLOT: '6685754230'
  },
  IN_FEED: {
    TYPE: 'in-feed',
    SLOT: '2184823320'
  },
  SQUARE_DISPLAY: {
    TYPE: 'square-display',
    SLOT: '7807264218'
  },
}

export const DEFAULT_LEAGUE_LINK = '/leagues/Premier League/645bec5ba42012fa6eb37334';
export const DEFAULT_TEAM_LINK = '/teams/Liverpool/6455eab25477a7f3d047a4cc';

export const SPORTS_CATEGORIES = [
  {
  label: 'Soccer',
  value: 'Soccer',
  },
  {
    label: 'UFC',
    value: 'mma',
  },
  {
    label: 'mma',
    value: 'ufc',
  },
  {
    label: 'F1',
    value: 'f1',
  },
  {
    label: 'MOTOGP',
    value: 'motogp',
  },
]

export const DIRECT_PLAYERS = [
  'TNT SPORTS FHD'
];

export const STREAMERS = ['freesport'];
export const REDDIT_STREAM = 'redditstream';
export const GREEN_PLAYER_SOURCES = ['Reddit-SoccerStreams', 'Reddit-Streams', 'Reddit-SoccerSt...']

export const OTHER_CATEGORIES = ['tennis', 'Cricket', 'F1', 'Boxing', 'nhl', 'nba', 'mls', 'mlb', 'MOTOGP'];
export const BLOG_CATEGORIES=['SOCCER', 'NFL', 'NBA', 'UFC', 'BOXING"', 'MOTOGP'];
export const BLOG_SITE_NAME='sportsfeed24to';